module.exports = __webpack_public_path__ + "img/daydreaming_2.ddd819ca.png";